<template>
   <div ref="headerContainer" class="header-nav" :class="{'fixed' : fixed, 'show-fixed' : showFixed, 'unfixing': unfixing }">
      <div class="main" ref="headerMain">
         <a ref="navMainLink" @click.prevent="open" href="#">Think Tank <img src="./../assets/images/carat.svg"></a>
      </div>
      <div ref="navLinks" class="header-links">
         <ul>
            <li v-for="(title, index) in linkTitles" class="mobile-nav-links">
               <a href="#"
                  :key="index"
                  class="adobe-clean-bold"
                  @click.prevent="scrollToSection(index)"
               >
                  {{ title }}
               </a>
            </li>
         </ul>
         <a class="adobe-clean-bold learn-more"
            href="http://www.adobe.com/industries/media-entertainment.html?promoid=9WGN456Y&mv=other" target="_blank">Learn More</a>
      </div>
   </div>
</template>

<script>
    import ScrollMagic from 'scrollmagic'
    import content from './../content'
    import 'TweenMax'
    import 'ScrollTo'
    import 'debug.addIndicators'

    export default {
        name: 'Header',
        data() {
            return {
                linkTitles: content.mobileTitles,
                links: null,
                scenes: null,
                fixed: false,
                showFixed: false,
                unfixing: false,
                smController: new ScrollMagic.Controller(),
                fixedHeaderScene: new ScrollMagic.Scene()
            }
        },
        methods: {
            open() {
                if (this.$refs.headerContainer.classList.contains('open')) {
                    this.$refs.headerContainer.classList.remove('open');
                    this.$refs.headerContainer.classList.add('closing');
                    this.$refs.headerContainer.addEventListener('transitionend', this.removeClosing);

                } else {
                    this.$refs.headerContainer.classList.add('open', 'opening');
                    this.$refs.headerContainer.addEventListener('transitionend', this.removeOpening);
                }
            },
            removeOpening () {
                this.$refs.headerContainer.classList.remove('opening');
                this.$refs.headerContainer.addEventListener('transitionend', this.removeOpening);
            },
            removeClosing () {
                this.$refs.headerContainer.classList.remove('closing');
                this.$refs.headerContainer.removeEventListener('transitionend', this.removeClosing);
            },
            changeActive(num) {
                for (var i = 0; i < this.links.length; i++) {
                    this.links[i].classList.remove('active')
                }

                this.links[num].classList.add('active')
            },
            scrollToSection(num) {

                this.changeActive(num);

                let destinationEl = num === 6 ? '.articles-end' : '#section-' + num;
                let scrollOffset = num === 6 ? -9999 : 50;

                this.$refs.headerContainer.classList.remove('open')
                this.$store.commit('allowMagic', false);
                TweenMax.set(window, {scrollTo: {y: destinationEl, offsetY: scrollOffset, autoKill: false}, ease: Expo.easeInOut});
                setTimeout(() => {
                    this.$store.commit('allowMagic', true);
                }, 800);
            },
            unFix () {
              this.fixed = false;
              this.showFixed = false;
              this.unfixing=  false;
              this.$refs.headerMain.removeEventListener('transitionend', this.unFix);
            }
        },
        mounted() {
            let headerHeight = this.$refs.headerMain.offsetHeight;
            this.$store.commit('getHeaderHeight', headerHeight);
            this.links = document.querySelectorAll('.mobile-nav-links')
            this.links[0].classList.add('active')

            for (var i = 0; i < this.links.length; i++) {
                let scene = new ScrollMagic.Scene();
                let num = i;
                let el = document.querySelector('#section-' + i);

                scene.triggerElement(el)
                    .on('start', (e) => {
                        if (e.scrollDirection === 'FORWARD') {
                            this.changeActive(num)
                        } else if (e.scrollDirection === 'REVERSE') {
                            this.changeActive(num - 1)
                        }
                    })
                    .addTo(this.smController)

            }

            this.fixedHeaderScene
               .offset(60 + this.$refs.headerMain.offsetHeight)
               .on('start', (e) => {
                 if (e.scrollDirection === 'FORWARD') {
                   this.fixed = true;
                   setTimeout(() => {
                     this.showFixed = true;
                   }, 200);
                 } else if (e.scrollDirection === 'REVERSE') {
                     this.unfixing = true;
                     this.$refs.headerMain.addEventListener('transitionend', this.unFix);
                 }
               })
               .addTo(this.smController)
               //.addIndicators({name: 'fixHeader'})
        }
    }
</script>

<style lang="scss">

   @import '../scss/the-goods';

   .header-nav {
      position : absolute;
      width    : 100%;
      z-index  : 99;

      &.fixed {
         position : fixed;
         top      : 0;

         .main {
            transform : translateY(-100%);
         }
      }

      &.show-fixed {
         .main {
            transition : transform 400ms $default-bez, opacity 400ms $default-bez;
            transform  : translateY(0);
         }
      }

      &.unfixing {
         .main {
            transform  : translateY(-100%);
            opacity    : 0;
         }
      }

      .main {
         display          : flex;
         justify-content  : center;
         align-items      : center;
         width            : 100%;
         height           : 50px;
         position         : absolute;
         background-color : black;
         z-index          : 10;
         transition : opacity 400ms $default-bez;

         a {
            margin          : 0px;
            color           : white;
            font-size       : 1.4rem;
            text-decoration : none;
            cursor          : pointer;

            img {
               transform        : rotate(180deg);
               transition       : transform $default-bez .3s;
               transform-origin : center;
            }
         }
      }

      .header-links {
         position       : absolute;
         width          : 100%;
         background     : white;
         top            : 50px;
         transform      : translateY(-100%);
         transition     : transform $default-bez .3s;
         display        : flex;
         flex-direction : column;
         align-items    : center;
         z-index        : 9;
         opacity        : 0;

         ul {
            list-style : none;
            padding    : 10px 30px;

            li {
               text-align : center;

               a {
                  display       : inline-block;
                  margin        : 10px 0px;
                  color         : black;
                  text-align    : center;
                  border-bottom : 2px solid transparent;
                  transition    : border .3s;
               }

               &.active {
                  a {
                     border-bottom : 2px solid black;
                  }
               }
            }
         }

         a.learn-more {
            background    : #1975E5;
            color         : #fff;
            padding       : 5px 23px;
            font-size     : 14px;
            border-radius : 30px;
            margin-bottom : 20px;
            display       : inline-block;
            transition    : background-color 0.3s $default-bez;

            &:hover {
               text-decoration  : none;
               background-color : #005abe;
            }
         }
      }

      &.open {

         .main {
            a img {
               transform : rotate(0deg);
            }
         }

         .header-links {
            transform : translateY(0%);
            opacity: 1;
         }
      }

      &.opening,
      &.closing {

         .header-links {
            opacity : 1;
         }
      }
   }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue